module.exports = __webpack_public_path__ + "img/5-3.422b3de3.png";